import React from "react";
import { AvForm, AvField, AvGroup } from "availity-reactstrap-validation";
import { StyledLabel, StyledSelectInput } from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import { useFetchGlobal } from "../../../../api/hooks";

import { useMoneticsForm } from "./MoneticsFormContext";
import { FieldError } from "./components/FieldError";

export function ValinaSwissConfig() {
    const { form, props } = useMoneticsForm();
    const {
        setIdIntegrator,
        setInputIdIntegrator,
        idIntegrator,
        inputIdIntegrator,
        setAutoValidate,
        autoValidate,
        inputCurrency,
        setCurrency,
        setInputCurrency,
        currency,
        typeTerminal: terminalType,
        inputTerminalType,
        setTypeTerminal: setTerminalType,
        setInputTerminalType,
    } = form;
    const { setIsEdited, isConsult } = props;
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();

    const [currencies, setCurrencies] = React.useState<any>([]);

    React.useEffect(() => {
        const getCurrencies = async () => {
            try {
                const result: any = await fetchGlobal(
                    `${process.env.REACT_APP_API_V2_URL}/settings/general/currencies/symbol`,
                    { method: "GET" }
                );

                setCurrencies(
                    result.data.map((el: any) => ({
                        label: el.key,
                        value: el.Symbole,
                    }))
                );
            } catch (error) {
                console.error("Error while fetching currencies:", error);
            }
        };
        getCurrencies();
        //eslint-disable-next-line
    }, []);

    return (
        <React.Fragment>
            <AvForm>
                <AvGroup>
                    <StyledLabel
                        htmlFor="example-input"
                        className="required__clz mt-3"
                    >
                        {t("Terminal type")}
                    </StyledLabel>
                    <AvField
                        data-testid="monetics-valina-swiss-terminal-type-input"
                        className={classnames({
                            input__clz: inputTerminalType,
                            readOnly__clz: isConsult,
                        })}
                        autocomplete="off"
                        id="terminalType"
                        name="terminalType"
                        placeholder={t("Write")}
                        type="text"
                        onChange={(e: any) => {
                            setTerminalType(e.target.value);
                            setInputTerminalType(false);
                            setIsEdited(true);
                        }}
                        value={terminalType}
                    />
                    {inputTerminalType && (
                        <FieldError>
                            {t("Please enter an integrator id")}
                        </FieldError>
                    )}
                </AvGroup>
                <AvGroup>
                    <StyledLabel
                        htmlFor="example-input"
                        className="required__clz mt-3"
                    >
                        {t("ID of integrator")}
                    </StyledLabel>
                    <AvField
                        data-testid="monetics-valina-swiss-integrator-id-input"
                        className={classnames({
                            input__clz: inputIdIntegrator,
                            readOnly__clz: isConsult,
                        })}
                        autocomplete="off"
                        id="idIntegrator"
                        name="idIntegrator"
                        placeholder={t("Write")}
                        type="text"
                        onChange={(e: any) => {
                            setIdIntegrator(e.target.value);
                            setInputIdIntegrator(false);
                            setIsEdited(true);
                        }}
                        value={idIntegrator}
                    />
                    {inputIdIntegrator && (
                        <FieldError>
                            {t("Please enter an integrator id")}
                        </FieldError>
                    )}
                </AvGroup>
                <AvGroup>
                    <StyledLabel
                        htmlFor="example-input"
                        className="required__clz mt-3"
                    >
                        {t("Automatic validation")} (auto-commit)
                    </StyledLabel>
                    <StyledSelectInput
                        data-testid="monetics-valina-swiss-auto-validate-select"
                        className={classnames({
                            readOnly__clz: isConsult,
                        })}
                        autocomplete="off"
                        id="AutoValidate"
                        name="AutoValidate"
                        type="text"
                        onChange={(e: any) => {
                            setAutoValidate(e);
                            setIsEdited(true);
                            setInputCurrency(false);
                        }}
                        options={[
                            {
                                label: t("True"),
                                value: t("True"),
                            },
                            {
                                label: t("False"),
                                value: t("False"),
                            },
                        ]}
                        value={autoValidate}
                        placeholder={`${t("Select")}…`}
                    />
                </AvGroup>
                <AvGroup>
                    <StyledLabel htmlFor="text" className="required__clz mt-3">
                        {t("Currency")}
                    </StyledLabel>
                    <StyledSelectInput
                        data-testid="monetics-valina-swiss-currency-select"
                        isClearable
                        className={classnames("mnt_drp_devise", {
                            invalid__clz: inputCurrency,
                            readOnly__clz: isConsult,
                        })}
                        noOptionsMessage={() => t("No options")}
                        options={currencies}
                        autocomplete="off"
                        name="change"
                        onChange={(e: any) => {
                            if (e !== null) {
                                setCurrency(e.label);
                            } else {
                                setCurrency("");
                            }
                            setIsEdited(true);
                            setInputCurrency(false);
                        }}
                        value={
                            currency === ""
                                ? null
                                : {
                                      label: currency,
                                      value: currency,
                                  }
                        }
                        placeholder={`${t("Select")}…`}
                        type="text"
                    />
                    {inputCurrency ? (
                        <FieldError>
                            {t("Please select a change")}
                        </FieldError>
                    ) : null}
                </AvGroup>
            </AvForm>
        </React.Fragment>
    );
}
